import imported_asset_index_tsx_0 from '../../../assets/Uploads/upper_management.svg';
import imported_asset_index_tsx_1 from '../../../assets/Uploads/partnership.svg';
import imported_asset_index_tsx_2 from '../../../assets/Uploads/report.svg';
import imported_asset_index_tsx_3 from '../../../assets/Uploads/serkan-yazicioglu.png';
import imported_asset_index_tsx_4 from '../../../assets/Uploads/duygu-tanit.jpg';
import imported_asset_index_tsx_5 from '../../../assets/Uploads/ozan-tuncer.jpeg';
import imported_asset_index_tsx_8 from '../../../assets/Uploads/ortaklik-yapisi.png';
import imported_asset_index_tsx_9 from '../../../assets/Uploads/ezgi_tuce.jpeg';
import imported_asset_index_tsx_10 from '../../../assets/Uploads/ebru-hamzakadi.jpg';
import MainBoxes from '../../../components/common/main-boxes';
import Title from "../../../components/modules/title";
import {CustomTextAccordion, CustomAccordion} from "../../../components/common/accordion";
import {useEffect, useRef, useState} from "react";
import {fetchCompliance} from "../../../actions/services";

const CorporateGovernancePage = () => {

    const upperManagementRef = useRef<HTMLDivElement | null>(null);
    const partnershipRef = useRef<HTMLDivElement | null>(null);
    const financialTablesRef = useRef<HTMLDivElement | null>(null);

    const defaultFundDetail = `Şirket’in 22.01.2025 itibari ile ödenmiş sermayesi 441.904.428,00 TL’dir.`

    const [fundDetail, setFundDetail] = useState(defaultFundDetail)

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await fetchCompliance();
                const fetchedFundDetail = `Şirket’in ${data?.fundDate} itibari ile ödenmiş sermayesi ${data?.fund} TL’dir.`

                setFundDetail(fetchedFundDetail)
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, []);


    const tfrs2021 = {
        text: "2021 Yemekpay TFRS raporuna ulaşmak için ",
        url: "/Yemekpay_31_12_2021_TFRS_Signed.pdf"
    };

    const tfrs2022 = {
        text: "2022 Yemekpay TFRS raporuna ulaşmak için ",
        url: "/YemekpayTFRS_31_12_2022_RaporuImzali.pdf"
    };

    const tfrs2023 = {
        text: "2023 Yemekpay TFRS raporuna ulaşmak için ",
        url: "/Yemekpay_2023_TFRS_RaporuImzalı.pdf"
    };

    const tfrs2024 = {
        text: "2024 Yemekpay TFRS raporuna ulaşmak için ",
        url: "/Yemekpay_2024_TFRS_RaporuImzalı.pdf"
    };

    const tfrs2025 = {
        text: "2025 Yemekpay TFRS raporuna ulaşmak için ",
        url: "/Yemekpay_2025_TFRS_RaporuImzalı.pdf"
    };

    const faaliyet2022 = {
        text: "2022 Yemekpay faaliyet raporuna ulaşmak için ",
        url: "/YemekpayFaaliyetRaporu2022_FinalGorus.pdf"
    }

    const faaliyet2023 = {
        text: "2023 Yemekpay faaliyet raporuna ulaşmak için ",
        url: "/Yemekpay_2023_FaaliyetRaporuImzali.pdf"
    }

    const faaliyet2024 = {
        text: "2024 Yemekpay faaliyet raporuna ulaşmak için ",
        url: "/Yemekpay_2024_FaaliyetRaporuImzali.pdf"
    }

    const faaliyet2025 = {
        text: "2025 Yemekpay faaliyet raporuna ulaşmak için ",
        url: "/Yemekpay_2025_FaaliyetRaporuImzali.pdf"
    }

    const items = [
        { title: 'Ünvanı', detail: 'Yemekpay Elektronik Para ve Ödeme Hizmetleri Anonim Şirketi (“Şirket”)' },
        { title: 'Merkez Adres ve İletişim Bilgileri', detail: '' },
        { title: 'Adres:', detail: 'Esentepe Mahallesi Dede Korkut Sokak 28/11 34394 Şişli/İstanbul' },
        { title: 'Telefon:', detail: '0212 274 18 00' },
        { title: 'Bilgi ve İletişim:', detail: 'musteridestek@yemekpay.com' },
        { title: 'Kuruluş Yer ve Tarihi:', detail: '26/11/2020 tarihinde tescil ve ilan edilmesi ile İstanbul’da kurulmuştur.' },
        { title: 'Ödenmiş Sermayesi:', detail: fundDetail },
        { title: 'Vergi Dairesi ve Numarası:', detail: 'Zincirlikuyu Vergi Dairesi Müdürlüğü - 9470916668' },
        { title: 'Mersis No:', detail: '094709166600001' },
        { title: 'Ticaret Sicil No:', detail: '279016-5' },
    ];


    return (
        <>
            <section className="governance">
                <div className="container large">
                    {/* MainBoxes Component */}
                    <MainBoxes
                        title="Kurumsal Yönetim"
                        items={[
                            {
                                title: "Üst Yönetim",
                                image: imported_asset_index_tsx_0,
                            },
                            {
                                title: "Sermaye ve Ortaklık Yapısı",
                                image: imported_asset_index_tsx_1,
                            },
                            {
                                title: "Finansal Tablolar",
                                image: imported_asset_index_tsx_2,
                            }
                        ]}
                        // onItemClick={(title) => title && setSelectedTitle(title)}
                    />
                </div>

                <div className="container large" style={{paddingTop: '0.3rem'}} ref={upperManagementRef}>
                    <div className="governance-container">
                        <Title size={4}>Üst Yönetim</Title>
                        <div className="text s1 row" style={{paddingTop: '0.3rem'}}>
                            <CustomAccordion
                                title="Serkan Yazıcıoğlu"
                                titleDetail="Yönetim Kurulu Başkanı ve Genel Müdür"
                                content="İstanbul Teknik Üniversitesi İnşaat Mühendisliği mezunu olan ve ardından Yıldız Teknik Üniversitesi İşletme Yönetimi Yüksek Lisans ve İstanbul Üniversitesi Uluslararası
                                İşletmecilik programlarını tamamlayan Serkan Yazıcıoğlu, Soyak İnşaat A.Ş bünyesinde 2 yıl İnşaat Mühendisi olarak çalıştıktan sonra, 1999- 2012 yılları arasında, 13 yıl boyunca
                                Türkiye’nin önde gelen özel bankalarından Finansbank’ta farklı yönetim kademelerinde görev aldı. Finansbank’taki kariyeri süresince Yazıcıoğlu, CardFinans markasının yaratılması
                                aşamasında önemli rol üstlendi; Ödeme Sistemleri Ürün Yönetimi, Pazarlama, Alternatif Dağıtım Kanalları ve Kart Operasyonları bölümlerinde üst düzey yöneticilik görevlerinde bulundu.
                                2012’de Bankalararası Kart Merkezi’nde, BKM Express ve TROY markaları başta olmak üzere tüm Dijital Çözümler ve Kartlı Ödeme Sistemleri’nden sorumlu Genel Müdür Yardımcısı olarak göreve
                                başlayan Yazıcıoğlu aynı zamanda BKM’de Pazarlama İletişiminden de sorumluydu. Serkan Yazıcıoğlu, Haziran 2021’de Yemeksepeti Pay Genel Müdürü görevine atandı."
                                photo={imported_asset_index_tsx_3}
                            />
                            <CustomAccordion
                                title="Duygu Tanıt"
                                titleDetail="Yönetim Kurulu Üyesi"
                                content="Yemeksepeti’nde Chief Legal Officer olarak görev yapan ve şirketin hukuki işlerini yöneten Duygu Tanıt, İstanbul Bilgi Üniversitesi’nde yüksek lisans eğitimini aldıktan sonra
                                kariyerine Postacıoğlu Hukuk Bürosu’nda stajyer avukat olarak başladı. Daha sonra GSI Meridian ve NN Hayat Emeklilik’te hukukun çeşitli alanlarında uzmanlaştı. 2015 yılında Yemeksepeti’ne
                                katıldığında ilk olarak Hukuk Departmanı Başkanı görevini üstlendi ve 2019 yılından itibaren Chief Legal Officer görevine atandı. Uzmanlığının yanı sıra London School of Economics and Political’da
                                rekabet hukuku üzerine bir yaz okulu programını tamamladı."
                                photo={imported_asset_index_tsx_4}
                            />
                            <CustomAccordion
                                title="Hamdi Ozan Tuncer"
                                titleDetail="İç Sistemlerden Sorumlu Bağımsız Yönetim Kurulu Üyesi"
                                content="İstanbul Üniversitesi İşletme Bölümü’nden 1995 yılında mezun olan Hamdi Ozan Tuncer, 1998 yılında Galler Üniversitesi’nde Bankacılık ve Finans alanında Yüksek Lisans öğrenimini tamamlamıştır.
                                İş hayatına 1999 yılında Finansbank A.Ş.’de başlamış, Temmuz 2006 itibariyle Fortis Bank A.Ş.’de Kampanya ve Analitik Müşteri İlişkileri Yönetimi Müdürü olarak devam etmiş olup Ekim 2007’de
                                Bireysel Krediler Tahsis ve Kredi Politikası Direktörlüğü görevine atanmıştır. Temmuz 2010 - Aralık 2011 tarihleri arasında Fortis Bank A.Ş.’nin birleşim sürecinde entegrasyon sürecini yönetimini gerçekleştirmiştir.
                                Aralık 2011’de Societe Generale SA’da Risk Yönetimi ve Tahsilat Direktörü olarak atanan Tuncer, sonrasında Experian Information Solutions Inc.’de Kıdemli Küresel Danışmanı ve Mayıs 2015’te Alternatifbank A.Ş. bünyesinde
                                Risk Yönetimi Direktörü görevlerini üstlenmiştir. Haziran 2017’den bugüne Sente Ventures LLC’de, Start Up Due Diligence, Risk Yönetimi ve Operasyonlardan sorumlu Venture Partner olarak kariyerine devam etmektedir. Kasım 2021’den bu yana ise şirketimizde Bağımsız Yönetim Kurulu Üyesi görevini sürdürmektedir."
                                photo={imported_asset_index_tsx_5}
                            />
                            <CustomAccordion
                                title="Ebru Hamzakadı"
                                titleDetail="İç Kontrol ve Uyumluluk Direktörü"
                                content="Yemekpay bünyesinde İç Kontrol ve Uyumluluk Direktörü olarak görev yapmakta olup; şirketin regülasyon uyumu, iç kontrol mekanizmaları ve MASAK süreçlerinin yönetiminden sorumludur.
                                Sakarya Üniversitesi İktisat Bölümü mezunu olan Hamzakadı, profesyonel kariyerine Citibank’ta Kredi Analisti olarak başlamıştır. Bankacılık kariyeri boyunca kredi değerlendirme, kredi kartları ve üye işyeri süreçleri alanlarında uzmanlaşmış; Citibank bünyesinde bu alanlara yönelik iş süreçlerinin geliştirilmesi ve yönetiminde İş Analisti olarak görev almıştır.
                                Kariyerinin devamında DenizBank İç Kontrol Departmanı’nda görev alan Hamzakadı; kredi, kredi kartları ve üye işyeri süreçlerinin kontrolü, iç kontrol faaliyetlerinin yürütülmesi ve projelere mevzuatsal uyum desteği sağlanması konularında deneyim kazanmıştır.
                                Türkiye’de Ödeme Hizmetleri mevzuatının şekillenmeye başladığı 2015 döneminde iyzico’da İç Kontrol Yöneticisi olarak görev alarak ödeme kuruluşlarında iç kontrol ve uyum süreçlerinin yapılandırılmasına katkı sağlamıştır. Ardından GönderAl Ödeme Hizmetleri’nde İç Kontrol Müdürü olarak görev yapmış; şirketin kontrol altyapısının geliştirilmesi ve mevzuat uyum süreçlerinin yönetilmesinden sorumlu olmuştur.
                                Sonrasında Yıldız Holding bünyesinde IT Governance ekibinde Bütçe Planlama Müdürü olarak üç yıl görev alan Hamzakadı, yönetişim, planlama ve bütçe yönetimi alanlarında deneyim kazanmıştır.
                                Kariyerinin devamında Asseco ve Payten çatısı altında faaliyet gösteren Paratika Ödeme Hizmetleri’nde yaklaşık beş yıl boyunca uyum ve iç kontrol süreçlerinin yönetiminden sorumlu olarak görev yapmıştır. Bu süreçte ödeme hizmetleri mevzuatı, operasyonel risk yönetimi, iç kontrol sistemlerinin geliştirilmesi, lisans/faaliyet genişlemesi ve düzenleyici gerekliliklere uyum alanlarında kapsamlı çalışmalar yürütmüştür.
                                Finansal teknolojiler, ödeme hizmetleri, regülasyon uyumu, iç kontrol ve MASAK süreçleri alanlarında güçlü bir uzmanlığa sahip olan Ebru Hamzakadı, sektörde edindiği uzun yıllara dayanan deneyimiyle şirketlerin sürdürülebilir, güvenli ve mevzuata uyumlu iş süreçleri geliştirmesine katkı sağlamaktadır."
                                photo={imported_asset_index_tsx_10}
                            />
                            <CustomAccordion
                                title="Ezgi Tuce"
                                titleDetail="Risk Yöneticisi"
                                content="Yeditepe Üniversitesi İktisat Bölümü'nden mezun olan ve Sabancı Universitesi'nde Professionals MBA programını tamamlayan Ezgi Tuce, çalışma hayatına Türk Ekonomi Bankası A.Ş.'de Risk Yönetimi Bölümü'nde başlamıştır. Ardından, PwC ve E&Y Türkiye bünyesinde finansal hizmetler sektörüne yönelik risk yönetimi ve süreç yönetimi danışmanlığında görev almıştır. Son olarak, ING Bank A.Ş.'de Uyum Risk Yönetimi Bölümü'nde görev yapmış olup; uyum risk değerlendirmeleri, izleme faaliyetlerinde ve üst yönetim raporlamalarında aktif rol almştır.  Bankacılık, finansal hizmetler ve danışmanlık sektöründe 10 yılı aşkın risk yönetimi ve uyum alanında deneyime sahiptir. Halihazırda Yemekpay Elektronik Para ve Ödeme Hizmetleri A.Ş.'de Risk Yönetimi'nden sorumlu Yönetici olarak çalışmaktadır."
                                photo={imported_asset_index_tsx_9}
                            />
                        </div>
                    </div>
                </div>

                <div className="container large" style={{paddingTop: '0.3rem'}} ref={partnershipRef}>
                    <div className="governance-container">
                        <Title size={4}>Sermaye ve Ortaklık Yapısı</Title>
                        <div className="text s1 row" style={{paddingTop: '0.3rem'}}>
                            <CustomAccordion
                                title="Ortaklık Yapısı"
                                titleDetail=""
                                content=""
                                graph={imported_asset_index_tsx_8}
                            />
                            <CustomTextAccordion items={items} mainTitle={"Şirket Bilgileri ve Sermaye"} />
                        </div>
                    </div>
                </div>

                <div className="container large" style={{paddingTop: '0.3rem'}} ref={financialTablesRef}>
                    <div className="governance-container">
                        <Title size={4}>Finansal Tablolar</Title>
                        <div className="text s1 row" style={{paddingTop: '0.3rem'}}>
                            <CustomAccordion
                                title="Bağımsız Denetim Raporları"
                                titleDetail=""
                                content=""
                                links={[tfrs2021, tfrs2022, tfrs2023, tfrs2024, tfrs2025]}
                            />
                            <CustomAccordion
                                title="Faaliyet Raporları"
                                titleDetail=""
                                content=""
                                links={[faaliyet2022, faaliyet2023, faaliyet2024, faaliyet2025]}
                            />
                        </div>
                    </div>
                </div>
            </section>


        </>
    )
}

export default CorporateGovernancePage;